import script from "./ListarOpcoesAvaliacoes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarOpcoesAvaliacoes.vue?vue&type=script&setup=true&lang=js"

import "./ListarOpcoesAvaliacoes.vue?vue&type=style&index=0&id=e5e3912a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5e3912a"]])

export default __exports__